import apiClient from './client';
import metaApiClient from './meta-client';
import type { User, CreateUserInput, CreateUserResponse } from '../../types/user';
import type { RegisterInput, RegisterResponse } from '../../types/auth';

// ========== USERS API ==========

// Listar todos os usuários
export const getUsers = async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/users');
    return response.data;
};

// Usuários com dados na plataforma Meta — alimenta o filtro "Usuário" do admin
export interface UsuarioDono { id: number; name: string; email?: string | null }
export const getUsuariosDonos = async (): Promise<UsuarioDono[]> => {
    // A rota é do ms-meta-api, não do api-rocketads (que responde 405 aqui).
    const response = await metaApiClient.get<UsuarioDono[]>('/users/donos');
    return response.data;
};

// Criar novo usuário
export const createUser = async (data: CreateUserInput): Promise<CreateUserResponse> => {
    const response = await apiClient.post<CreateUserResponse>('/auth/register', data);
    return response.data;
};

// Buscar usuário por ID
export const getUserById = async (id: number): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${id}`);
    return response.data;
};

// Atualizar usuário (quando implementar no backend)
export const updateUser = async (id: number, data: Partial<User>): Promise<User> => {
    const response = await apiClient.put<User>(`/users/${id}`, data);
    return response.data;
};

// Deletar usuário
export const deleteUser = async (id: number): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
};

// Registro público (cria usuário inativo, sem auth)
export const registerUser = async (data: RegisterInput): Promise<RegisterResponse> => {
    const response = await apiClient.post<RegisterResponse>('/register', data);
    return response.data;
};

// Listar usuários pendentes de aprovação (admin)
export const getPendingUsers = async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/users/pending');
    return response.data;
};

// Aprovar usuário (admin)
export const approveUser = async (id: number): Promise<{ message: string; success: boolean }> => {
    const response = await apiClient.patch(`/users/${id}/approve`);
    return response.data;
};

// Rejeitar usuário (admin)
export const rejectUser = async (id: number): Promise<{ message: string; success: boolean }> => {
    const response = await apiClient.patch(`/users/${id}/reject`);
    return response.data;
};

interface UserConfig {
    user_id: number;
    spread: number | null;
}

interface UserConfigUpdate {
    spread?: number | null;
}

export const getUserConfig = async (): Promise<UserConfig> => {
    const response = await apiClient.get('/users/me/config');
    return response.data;
};

export const updateUserConfig = async (data: UserConfigUpdate): Promise<UserConfig> => {
    const response = await apiClient.patch('/users/me/config', data);
    return response.data;
};
